module.exports = __webpack_public_path__ + "img/noble-level3-img.a05d67fa.png";